import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'
import { TimeApprovalsPage } from '../../../../features/projects/time/approvals-page'
import { timeApprovalsSearchSchema } from '../../../../features/projects/time/search'

/**
 * Time approvals (projects/06 §5.9): projects.time_approve holders, and project managers on their own
 * projects (the API decides who sees which entries).
 */
export const Route = createFileRoute('/_app/projects/time/approvals')({
  staticData: { crumb: 'projectTimeApprovals' },
  validateSearch: timeApprovalsSearchSchema,
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.time_approve', 'projects.read'),
  component: TimeApprovalsPage,
})
